import React from "react";
import { Link } from "gatsby";
import logo from "../../static/images/logo.svg";
import footerMap from "../../static/images/footer-map.png";
import {
  CAREER_PLATFORM_URL,
  trackCareerEvent,
} from "../CareerPlatform/CareerPlatformContent";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-area modern-footer">
      <div className="container">
        <div className="footer-top">
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6">
              <div className="single-footer-widget footer-brand">
                <Link to="/" className="logo">
                  <img src={logo} alt="CloudLogic IT Solutions logo" />
                </Link>

                <p>
                  Microsoft cloud transformation, digital workplace, security
                  and governance support for organisations that need stronger
                  Microsoft 365, Azure, collaboration, automation, identity,
                  data protection, and audit-readiness controls.
                </p>

                <div className="footer-trust-tags">
                  <span>Microsoft 365</span>
                  <span>Azure</span>
                  <span>SharePoint</span>
                  <span>Defender</span>
                </div>

                <ul className="social-link">
                  <li>
                    <a
                      href="https://www.facebook.com/profile.php?id=61566567241534"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Facebook"
                    >
                      <i className="bx bxl-facebook"></i>
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://www.linkedin.com/company/113323042"
                      target="_blank"
                      rel="noreferrer"
                      aria-label="LinkedIn"
                    >
                      <i className="bx bxl-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 col-sm-6">
              <div className="single-footer-widget">
                <h3>Quick Links</h3>

                <ul className="footer-links-list">
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <Link to="/about-us">About</Link>
                  </li>
                  <li>
                    <Link to="/services">Services</Link>
                  </li>
                  <li>
                    <Link to="/solutions/career-application-platform">
                      Career Platform
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6 col-sm-6">
              <div className="single-footer-widget">
                <h3>Core Services</h3>

                <ul className="footer-links-list">
                  <li>
                    <Link to="/services">Microsoft 365 Transformation</Link>
                  </li>
                  <li>
                    <Link to="/services">SharePoint & Teams Solutions</Link>
                  </li>
                  <li>
                    <Link to="/services">Azure Managed Cloud Support</Link>
                  </li>
                  <li>
                    <Link to="/services">Security & Compliance Readiness</Link>
                  </li>
                  <li>
                    <Link to="/solutions/career-application-platform">
                      Career Application Platform
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-lg-3 col-md-6">
              <div className="single-footer-widget footer-contact-widget">
                <h3>Book a Health Check</h3>

                <ul className="footer-contact-info">
                  <li>
                    <i className="bx bx-map"></i>
                    <div>
                      Melbourne, VIC, Australia
                      <span>Supporting clients locally and remotely</span>
                    </div>
                  </li>

                  <li>
                    <i className="bx bx-phone-call"></i>
                    <a href="tel:+61420719901">(+61) 0420 719 901</a>
                  </li>

                  <li>
                    <i className="bx bx-envelope"></i>
                    <a href="mailto:info@cloudlogicit.com.au">
                      info@cloudlogicit.com.au
                    </a>
                  </li>
                </ul>

                <div className="footer-cta">
                  <Link to="/contact" className="default-btn">
                    Book Microsoft 365 Health Check
                  </Link>
                  <a
                    href={`${CAREER_PLATFORM_URL}?utm_source=cloudlogic_main_site&utm_medium=referral&utm_campaign=career_platform&utm_content=footer_cta`}
                    className="footer-product-link"
                    onClick={() =>
                      trackCareerEvent(
                        "career_platform_footer_start_click",
                        CAREER_PLATFORM_URL
                      )
                    }
                  >
                    Create Career Application
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-area">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6">
              <p>
                © {currentYear} <strong>CloudLogic IT Solutions</strong>.
                Microsoft cloud transformation, security, governance, and
                managed IT support.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-map">
        <img src={footerMap} alt="Footer background map" />
      </div>
    </footer>
  );
};

export default Footer;
